<i18n lang='yml' src='../i18n/BookingSitting.yml'></i18n>

<template>
  <div v-if="active">
    <div class='row'>
      <div class="col-sm-12 mb-4">
        <h5 class="heading-page">
          {{$t('details')}} 
        </h5>
        <p v-if="type == 'edit' && details.training_program">
          {{details.training_program.name[locale]}} - {{details.exam_type.name[locale]}}</p>
        <p v-else-if="details.exam_type_name"> {{details.training_program_full_name}} - {{details.exam_type_name[locale]}}</p>
        <h6 class="margin-top heading-page">
           {{ $t('select_multiple_locations') }}
          <span class="red">*</span>
        </h6>
      <div class='row'>
        <div 
          class="col-sm-12 col-lg-6 col-xl-5"
          :class="{'is-invalid': isInvalid}">
          <label>
            {{ $t('select_locations') }}
          <span class="red">*</span>
          </label>
          <multi-select
            :options="dropdownLocations"
            searchable="true"
            :clearOnSelect="true"
            class="single-select"
            :disabled="taggedSelectedSubLocation.length  >= 5 || type == 'edit'"
            :placeholder="$t('select_placeholder')"               
            @input="appendToSelected"
            ref="multiselect"
            label="label"
            valueProp="id"
            key="id"
            />
          <div class="invalid-feedback" id="inter_provincial_exam_error" v-if="isInvalid">
            <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
              {{`${$t('select_locations')} ${$t('blank_error')}`}} 
          </div>
        </div>
      </div>
      <div class='row'>
        <div class="col-sm-12">
          <label class="margin-top">
           {{ $t('selected_locations')}} 
            <span class="red">*</span>
          </label>
                          
          <ul class="selected-locations mb-0" :class="{'is-invalid': isInvalid}" >
            <li class="tag-selected" v-for="location in taggedSelectedSubLocation" :key="location.id">
              <span class="mr-2">
                {{location.label}}
              </span>
              <button @click="removeLocation({location_id: location.id})" :aria-label="$t('remove')" class="btn">
                <font-awesome-icon :icon="['fa', 'times']"/>
              </button>
            </li>
          </ul>
          <div class="invalid-feedback" id="inter_provincial_exam_error" v-if="isInvalid">
            <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
              {{`${$t('selected_locations')} ${$t('blank_error')}`}} 
          </div>
         
          <button href="#" :disabled="taggedSelectedSubLocation.length == 0" @click="showSelectedLocations" class="btn btn-md btn-success mt-3">{{$t('view_locations')}} </button>
        </div>
      </div>
    </div>
  </div>
  <calendar v-if="selectedSubLocations.length > 0 && viewSelectedLocations" 
    @nextStep="nextStep" 
    @removeLocation="removeLocation" 
    @sittingChange="sittingChange"
    :base_path="base_path" 
    :locale="locale" 
    :booking_details='details' 
    :sub_locations_path="sub_locations_path" 
    :selected_sub_locations="selectedSubLocations"
    :time_format_en="time_format_en" :time_format_fr="time_format_fr"
    :admin="admin"
    context="booking"
    :type="type"
  />
  </div>
</template>
<script>
import CalendarVue from '../../../shared/calendar/components/Calendar.vue'
import flash from '../../../shared/flash_messages/components/Flash.vue';
import Stepper from './Stepper.vue'
  export default {
  props: ['locale', 'base_path', 'admin', 'sub_locations', 'path_scheduling', 'details', "sub_locations_path", 'userEligibility', 'active', 'booking_holds_path', 'type', 'time_format_en', 'time_format_fr'],
  components: {
    'calendar': CalendarVue, Stepper, flash
  },
  data() {
    return {
      subLocations: [],
      maxNumber: 5,
      taggedSelectedSubLocation: [],
      selectedSubLocations: [],
      selectedSitting: null,
      selectedValue: null,
      sittings: [],
      viewSelectedLocations: false,
      isInvalid: false
    }
  },
  watch: {
    active(newVal) {
      if(newVal) {
        this.selectedValue = null
        if(this.details.booking_accommodations) {
          this.details.accommodations ||= {accommodation_types: this.details.booking_accommodations.map((accommodation) => {return accommodation.accommodation_type})}
        }
        this.sendAjaxRequest(
          'GET',
          `${this.base_path}/available_sub_locations`,
          {
            exam_type_id: this.details ? this.details.exam_type_id : null, 
            training_program_id: this.details ? this.details.training_program_id : null,
            booking_for_identity_id: this.details ? this.details.user_identity_id : null,
            accommodations: this.details && this.details.accommodations ? this.details.accommodations.accommodation_types : null
          },
          this.setSubLocations
        )
        if (this.type == "edit") {
          this.details.sittings.forEach((sitting) => {
            let found = this.taggedSelectedSubLocation.find(obj => obj.id === sitting.sub_location.id);
            if (!found){
              this.taggedSelectedSubLocation.push({id: sitting.sub_location.id, label: sitting.sub_location.name[this.locale]});
              this.selectedSubLocations.push(sitting.sub_location)
            }
          })
          this.selectedValue = {id: this.details.sittings[0].sub_location.id, label: this.details.sittings[0].sub_location.name[this.locale]}
          this.viewSelectedLocations = true
        }
      }
    },
  },
  computed: {
  
    // Set the locations dropdown data
    // Don't add any sub locations that are already selected
    dropdownLocations() {   
      let results = [];
      for (const [key, value] of Object.entries(this.subLocations)) {
        let found = this.taggedSelectedSubLocation.find(obj => obj.id === value.id);
        if (!found) {
          results.push({
            id: value.id,
            label: this.$i18n.t(value.name[this.locale])
          });
        }
      };
      return results;
    }
  },


  methods: {
    nextStep() {
      this.sendAjaxRequest(
          'POST',
          this.booking_holds_path,
          {booking_hold: this.details}
      )
      this.$emit('nextStep')
    },

    sittingChange(sittings) {
      // We do this duplication of id for the nested attributes we need to create the booking dates in controller
      let booking_dates_attributes = []
      sittings.forEach((sitting) => {
        booking_dates_attributes.push({sitting_id: sitting.id})
      })
      this.$emit('sittingChange', {
        'sittings': sittings,
        'booking_dates_attributes': booking_dates_attributes,
      })
    },
  
    setSubLocations(data) {
      this.loading = false
      this.subLocations = data
    },

    appendToSelected(item) {
      if(!item) {
        return
      }
      let location = this.dropdownLocations.find((location) => {return location.id == item})
      this.isInvalid = false;
      let found = this.taggedSelectedSubLocation.find(obj => obj.id === location.id);
      if (!found) {
        this.taggedSelectedSubLocation.push(location)
      }
      this.$refs.multiselect.deselect(item)
    },

    showSelectedLocations() {
      this.viewSelectedLocations = true
      this.setSelectedLocations()
    },

    removeLocation(item) {
      if ( item.location_id) {
        this.taggedSelectedSubLocation = this.taggedSelectedSubLocation.filter(location => location.id !== item.location_id)
        this.selectedValue = this.selectedValue && this.selectedValue.id == item.location_id ?  null : this.selectedValue   
      } else {
  
        this.taggedSelectedSubLocation = this.taggedSelectedSubLocation.filter(location => location.id !== item)
        this.selectedValue = this.selectedValue && this.selectedValue.id == item ?  null : this.selectedValue       
      }  
      this.setSelectedLocations()
    },

    setSelectedLocations() {
      
      let locations = [];
      this.taggedSelectedSubLocation.map((selected) => {
        const _vm = this
        _vm.subLocations.map((location) => {
          if (location.id == selected.id) {
            locations.push(location)
          }
        })   
      })
      this.selectedSubLocations = locations;
      if (locations.length == 0 && this.viewSelectedLocations == true) {
        this.isInvalid = true
        this.viewSelectedLocations = false
      }
    },

    sendAjaxRequest(method, url, data, success) {
      const _vm = this
      $.ajax({
        type: method,
        url: `${url}.json`,
        data_type: 'json',
        data: data,
        success: success,
        error(message) {
          _vm.loading = false;
          alert(_vm.$t('error_loading'));
        }
      });
    },
  }
}
</script>
